<!-- <ul *ngIf="reportItems">
<orthofoto-module
  *ngFor="let reportItem of reportItems"
  [config]="reportItem"
></orthofoto-module>
</ul>
-->
@if (reportItems && reportItems.length !== 0) {
  <app-global-time-settings
    data-test-id="global-time-settings"
  ></app-global-time-settings>
}

@if (reportItems && reportItems.length !== 0) {
  <div class="report-container">
    @for (reportItem of reportItems; track reportItem) {
      <report-module-loader
        class="report-element"
        [reportModule]="reportItem"
      ></report-module-loader>
    }
  </div>
}

@if (userService.userIsAdmin) {
  <div
    class="add-report-button-container d-flex justify-content-center align-items-center"
    data-test-id="add-report-button-container"
    >
    <div class="add-report-button d-flex flex-row align-items-center">
      <div class="p-2 button-text">Element hinzufügen</div>
      <button
        class="ml-auto"
        mat-fab
        color="primary"
        aria-label="Element hinzufügen"
        (click)="addComponent($event)"
        >
        <mat-icon>add</mat-icon>
      </button>
    </div>
  </div>
}
